import { WTActions } from '@js/WTPayload'

export type TrackingEvent = {
  value: string
  label?: string
  location?: string
  category?: CategoryValue
  action?: WTActions
  type?: string
  name?: string
  text?: string
  url?: string
  from?: string
  to?: string
}

export const TrackingEventCategoryType = {
  CTAlink: 'CTA-link',
  CTAbutton: 'CTA-button',
  radiobutton: 'radiobutton',
  checkbox: 'checkbox',
  login: 'login'
} as const

type CategoryKey = keyof typeof TrackingEventCategoryType
type CategoryValue = typeof TrackingEventCategoryType[CategoryKey]

type CTAButtonTrackingEvent = TrackingEvent & {
  category?: typeof TrackingEventCategoryType['CTAbutton']
}

type CTALinkTrackingEvent = Required<Pick<TrackingEvent, 'url'>> &
  TrackingEvent & {
    category?: typeof TrackingEventCategoryType['CTAlink']
  }

type RadiobuttonTrackingEvent = Required<Pick<TrackingEvent, 'type'>> &
  TrackingEvent & {
    category?: typeof TrackingEventCategoryType['radiobutton']
  }

type CheckboxTrackingEvent = Required<Pick<TrackingEvent, 'type'>> &
  TrackingEvent & {
    category?: typeof TrackingEventCategoryType['checkbox']
  }

type LoginTrackingEvent = Required<Pick<TrackingEvent, 'action'>> &
  TrackingEvent & {
    category?: typeof TrackingEventCategoryType['login']
  }

/* $TSFixMe type TrackingEvent = {[K in CategoryValue]: TrackingEvent}
 Got stuck with it, TrackingEvent type is wider than specific like LoginTrackingEvent. I want to ensure that specific type of even is bound together, not sure how to type it */

export const trackingEvent = {
  'CTA-button': ({
    value,
    action,
    category,
    ...rest
  }: CTAButtonTrackingEvent) => {
    window._wt({
      category: TrackingEventCategoryType.CTAbutton,
      action: action || 'click',
      values: [{ type: 'text', value: value }],
      ...rest
    })
  },
  'CTA-link': ({
    action,
    url,
    value,
    category,
    ...rest
  }: CTALinkTrackingEvent) => {
    window._wt({
      category: TrackingEventCategoryType.CTAlink,
      action: action || 'click',
      values: [
        {
          type: 'url',
          value: encodeURIComponent(
            `${window.location.protocol}${window.location.host}/servicewelt-bauen/${url}`
          )
        },
        { type: 'text', value: value ?? '' }
      ],
      ...rest
    })
  },
  radiobutton: ({
    action,
    type,
    value,
    category,
    ...rest
  }: RadiobuttonTrackingEvent) => {
    window._wt({
      category: TrackingEventCategoryType.radiobutton,
      action: action || 'click',
      values: [{ type: type, value }],
      ...rest
    })
  },
  checkbox: ({
    action,
    type,
    value,
    category,
    ...rest
  }: CheckboxTrackingEvent) => {
    window._wt({
      category: TrackingEventCategoryType.checkbox,
      action: action || 'click',
      values: [{ type: type ?? '', value }],
      ...rest
    })
  },
  login: ({ action, value, category, ...rest }: LoginTrackingEvent) => {
    window._wt({
      category: TrackingEventCategoryType.login,
      action,
      values: [
        { type: 'password', value: 'VALUE-HIDDEN' },
        { type: 'magic-token', value: 'VALUE-HIDDEN' },
        { type: 'account-creation', value: 'VALUE-HIDDEN' }
      ].filter(({ type }) => type === value),
      ...rest
    })
  }
}
